import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../Context/AuthContext";
import "./PublishingMethodsCards.css";

const publishingMethodsData = [
  {
    tags: "저자 주도형",
    title: "자비 출판",
    subtitle: ["저자가 출간 비용을 부담하고 방향을 주도하며", "출판사가 제작·유통·정산을 지원하는 방식"],
    features: [
      "전자책 출간 기본, 종이책 선택 가능",
      "출간 방향과 제작 사양을 저자와 협의",
      "편집 · 디자인 · 제작 · 유통 서비스 선택 가능",
      "종이책 인세 : 정가의 50%",
      "전자책 인세 : 판매 순수익의 60%",      
    ],
    className: "card-self-publishing",
    path: "/self-publishing",
  },
  {
    tags: "협력 분담형",
    title: "반기획 출판",
    subtitle: ["저자와 출판사가 비용·역할·기획 방향을", "함께 협의해 출간하는 방식"],
    features: [
      "원고의 가능성과 저자의 활동 기반을 함께 검토",
      "출판사의 기획 · 편집 · 디자인 · 제작 인프라 활용",
      "비용, 역할, 마케팅 범위는 협의 후 계약 기준에 따라 분담",
      "ISBN 등록 및 주요 온라인 서점 유통 가능",
      "판매 수익은 계약 기준에 따라 정산",      
    ],
    className: "card-half-planned-publishing",
    path: "/semi-planned-publishing",
  },
  {
    tags: "출판사 주도형",
    title: "기획 출판",
    subtitle: ["출판사가 제작 비용과 판매 리스크를 부담하고", "기획부터 유통·마케팅까지 주도하는 방식"],
    features: [
      "출판사 주도의 기획 · 편집 · 디자인 · 마케팅 진행",
      "저자는 원고 집필과 검토 과정에 참여",
      "출판사가 주요 제작비와 유통 비용 부담",
      "주요 온 · 오프라인 서점 및 전자책 플랫폼 유통",
      "저자는 계약 기준에 따라 인세 수령",
      "출판사 검토를 거쳐 진행 여부 결정",
    ],
    className: "card-planned-publishing",
    path: "/planned-publishing",
  },
  {
    tags: "글로벌 전략형",
    title: "아마존 킨들 출판 대행",
    subtitle: [
      "Amazon Kindle 플랫폼에 전자책 또는 POD 도서를 등록하고 유통하는 방식",
    ],
    features: [
      "전 세계 Amazon Kindle 스토어에 자동 유통",
      "번역, 표지 디자인, KDP 등록 등 전 과정 대행",
      "주문형 인쇄(POD)로 인쇄 및 재고 부담 없음",
      "저자 100% 직접 투자 방식",
      "판매 수익의 최대 70% 저자 귀속(KDP 기준)",
      "ISBN 발급, 미국 세금정보 등록, 글로벌 서점 검색 최적화(SEO) 지원",
    ],
    className: "card-amazon-publishing",
    path: "/amazon",
  },
];

const PublishingMethodsCards = () => {
  // const { isLoggedIn } = useAuth();
  const navigate = useNavigate();

  const handleQuoteClick = () => {
    // if (isLoggedIn) {
    //   navigate("/quote");
    // } else {
    //   // alert("견적서 페이지는 로그인이 필요합니다.");
    //   const confirmed = window.confirm("견적서 페이지는 로그인이 필요합니다.\n\n로그인 하시겠습니까?");
    //   if (confirmed) {
    //     navigate("/login");
    //   }
    // }
    navigate("/quote");
  };
  
  return (
    <section className="publishing-methods-cards-section">
      <p className="section-pretitle">
        출판 목적과 예산, 일정에 따라 가장 적합한 방식을 함께 찾아드립니다.
      </p>
      <h1 className="section-main-title">
        나에게 맞는 출판 방식을 찾아보세요!
      </h1>
      <div className="publishing-methods-cards-container">
        {publishingMethodsData.map((card, index) => (
          <Link
            key={index}
            to={card.path}
            className={`publishing-methods-card ${card.className}`}
          >
            <div className="card-tags">
              <span key={card.tags} className="tag">
                {card.tags}
              </span>
            </div>
            <h2 className="card-title">{card.title}</h2>
            <p className="card-subtitle">
              {card.subtitle[0]}
              <br />
              <span className="card-subtitle">{card.subtitle[1]}</span>
            </p>
            <hr className="card-divider" />
            <ul className="card-features-list">
              {card.features.map((feature, featureIndex) => (
                <li key={featureIndex}>{feature}</li>
              ))}
            </ul>
            {/* <Link to={card.path} className="card-button">
              자세히 보기
            </Link> */}
          </Link>
        ))}
      </div>
      <div className="get-started-buttons">
        <button onClick={handleQuoteClick} className="section-button">
          모의 견적 산출
        </button>
        <Link to="/get-started" className="section-button">
          출판 상담 신청하기
        </Link>
      </div>
    </section>
  );
};

export default PublishingMethodsCards;
